<template>
  <div v-if="visible" class="wg-toast" role="status">
    <i class="material-icons">{{ kind === 'error' ? 'error_outline' : 'check' }}</i>
    <span>{{ message }}</span>
    <button v-if="action" class="wg-toast-act" @click="runAction">{{ action.label }}</button>
  </div>
</template>

<script>
/**
 * Design-mock toast: bottom-center teal bar with a green check, optional
 * underlined action (e.g. Undo). Host it once per tab and expose
 * `show(message, action?, kind?)` to children via provide/inject.
 */
export default {
  name: 'WgToast',
  data () {
    return {
      visible: false,
      message: '',
      kind: 'success',
      action: null,
      timer: null,
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    /**
     * @param {string} message
     * @param {{label: string, onClick: Function}|null} action
     * @param {'success'|'error'} kind
     */
    show (message, action = null, kind = 'success') {
      clearTimeout(this.timer)
      this.message = message
      this.action = action
      this.kind = kind
      this.visible = true
      this.timer = setTimeout(() => this.hide(), action ? 6000 : 2600)
    },
    hide () {
      clearTimeout(this.timer)
      this.visible = false
      this.action = null
    },
    runAction () {
      const action = this.action
      this.hide()
      if (action && action.onClick) action.onClick()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './wg-tokens.scss';

.wg-toast {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  background: $pop-teal;
  color: #fff;
  border-radius: 8px;
  padding: 13px 20px;
  font-size: 0.85rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: $shadow-menu;
  z-index: 70;
  animation: wgtoastin 0.25s ease;

  .material-icons {
    font-size: 1.1rem;
    color: $pop-scale-green;
  }
}

.wg-toast-act {
  background: none;
  border: none;
  color: #fff;
  font-weight: 800;
  font-size: 12.5px;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 12px;
  padding: 0;
}

@keyframes wgtoastin {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>
